<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span jhiTranslate="germplasm-list-creation.header"></span>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" data-test="modal-close-button"
            (click)="closeModal()" [disabled]="isLoading">
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col">
            <div class="row">
                <div class="col">
                    <h5 jhiTranslate="germplasm-list-creation.folder-section-title"></h5>
                </div>
                <div class="col">
                    <div class="float-end">
                        <img (click)="setMode(FolderModes.Add, $event)" src="content/images/add2.png" class=""
                             [ngClass]="{ 'disable-image': this.isAddActionDisabled() }"/>
                        <img (click)="setMode(FolderModes.Rename, $event)" src="content/images/edit.png" class="ps-1"
                             [ngClass]="{ 'disable-image': this.isRenameActionDisabled() }"/>
                        <img (click)="setMode(FolderModes.Delete, $event)" src="content/images/delete.png" class="ps-1"
                             [ngClass]="{ 'disable-image': this.isDeleteActionDisabled() }"/>
                    </div>
                </div>
            </div>

            <div id="addFolderDiv" *ngIf="mode == FolderModes.Add || mode == FolderModes.Rename">
                <div class="mb-3 row">
                    <label class="col-sm-5 col-form-label fw-bold">{{ 'common.folder.action.' + Modes[mode].toString().toLowerCase() | translate }}</label>
                    <div class="col-sm-7 input-group" style="height: 34px">
                        <input type="text" class="form-control" placeholder="{{ 'common.folder.name' | translate }}" [(ngModel)]="this.name"
                               jhi-forbiddenCharactersValidator maxlength="{{ NAME_MAX_LENGTH }}" data-test="folder-name-input"/>
                        <button class="btn btn-success" [title]="'common.folder.title.' + Modes[mode].toString().toLowerCase() | translate" data-test="confirm-folder-button"
                                [disabled]="containsForbiddenCharacters(name)" (click)="submitAddOrRenameFolder()">
                            <span class="fa fa-check"></span>
                        </button>
                        <button class="btn btn-danger" title="{{ 'common.form.cancel.text' | translate }}" (click)="mode = FolderModes.None" data-test="cancel-folder-button">
                            <span class="fa fa-close"></span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="clearfix"></div>
            <div class="table-responsive custom-scroll-style" style="max-height: 800px; overflow-y: auto;">
                <p-tree [value]="nodes"
                        [(selection)]="_selectedNodes"
                        [draggableNodes]="true"
                        [droppableNodes]="true"
                        [validateDrop]="true"
                        (onNodeSelect)="onNodeSelect($event)"
                        (onNodeDrop)="onNodeDrop($event, $event.dragNode, $event.dropNode)"
                        (onNodeExpand)="onNodeExpand($event)"
                        autoLayout="true"
                        [selectionMode]="selectionMode"
                        draggableScope="self"
                        droppableScope="self"
                        styleClass="tree-table">
                    <ng-template pTemplate="default" let-node>
                        <span [ngClass]="{ 'folder': !node.leaf, 'file': node.leaf }"></span>
                        {{translateName(node.data)}}
                    </ng-template>
                </p-tree>
            </div>
        </div>
        <div class="col">
            <h5 jhiTranslate="germplasm-list-creation.details-section-title"></h5>
            <br/>
            <form name="form" #f="ngForm">
                <div class="mb-3 row">
                    <label for="name" class="col-sm-3 col-form-label"
                           jhiTranslate="germplasm-list-creation.name"></label>
                    <div class="col-sm-9">
                        <input type="text" class="form-control" id="name" name="name" [(ngModel)]="model.listName"
                               jhi-forbiddenCharactersValidator data-test="name" required/>
                    </div>
                </div>
				<div *ngIf="showListOwner" class="mb-3 row">
					<label for="description" class="col-sm-3 col-form-label"
						   jhiTranslate="germplasm-list-creation.owner"></label>
					<div class="col-sm-9">
						<input type="text" class="form-control" id="owner" name="owner"
						   [(ngModel)]="model.listOwner" jhi-forbiddenCharactersValidator readonly data-test="owner"/>
					</div>
				</div>
                <div class="mb-3 row">
                    <label for="description" class="col-sm-3 col-form-label"
                           jhiTranslate="germplasm-list-creation.description"></label>
                    <div class="col-sm-9">
                        <input type="text" class="form-control" id="description" name="description"
                               [(ngModel)]="model.description" jhi-forbiddenCharactersValidator data-test="description"/>
                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="type" class="col-sm-3 col-form-label"
                           jhiTranslate="germplasm-list-creation.type"></label>
                    <div class="col-sm-9">
                        <select class="form-select" name="dropdownTypes" id="dropdownTypes" [(ngModel)]="model.listType"
                                #dropdownTypes="ngModel" required data-test="type">
                            <option *ngFor="let type of listTypes" [value]="type.code">
                                <label>{{ type.name }}</label>
                            </option>
                        </select>
                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="type" class="col-sm-3 col-form-label"
                           jhiTranslate="germplasm-list-creation.date"></label>
                    <div class="col-sm-9">
                        <div class="input-group">
                            <input class="form-control w-50" [placeholder]="'global.date.placeholder' | translate" [(ngModel)]="creationDate"
                                   ngbDatepicker #date="ngbDatepicker" id="date" name="date" required data-test="date"/>
                            <button class="btn btn-outline-secondary calendar" (click)="date.toggle()"
                                    type="button" data-test="date-calendar-button"><i class="fa fa-calendar"></i></button>
                        </div>
                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="notes" class="col-sm-3 col-form-label"
                           jhiTranslate="germplasm-list-creation.notes"></label>
                    <div class="col-sm-9">
						<textarea type="text" class="form-control" id="notes" name="notes" [(ngModel)]="model.notes"
                                  jhi-forbiddenCharactersValidator
                                  rows="4"></textarea>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()"
            [disabled]="isLoading" data-test="cancelSaveList">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel"></span>
    </button>
    <button (click)="save()" [disabled]="!isFormValid(f)" class="btn btn-primary" data-test="saveList">
        <span *ngIf="isLoading" class="throbber throbber-btn"></span>
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="save"></span>
    </button>
</div>
